// extracted by mini-css-extract-plugin
module.exports = {"form-card-group":"FormCardGroup_form-card-group__MbpZp"};